"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconShrinkScreen = function IconShrinkScreen(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 50 50",
    width: size,
    height: size,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.084 23.25h9.438a1.382 1.382 0 100-2.762h-6.123L42.402 9.486a1.381 1.381 0 10-1.934-1.934L29.466 18.555v-6.123a1.381 1.381 0 10-2.763 0v9.437a1.381 1.381 0 001.381 1.382zM7.464 42.628a1.381 1.381 0 001.933-.046l10.91-11.141.047 6.123a1.38 1.38 0 102.762-.046l-.138-9.438a1.381 1.381 0 00-1.381-1.38l-9.438.137a1.381 1.381 0 10.046 2.762l6.123-.091-10.864 11.14a1.381 1.381 0 000 1.98z",
    fill: color
  }));
};

IconShrinkScreen.defaultProps = {
  color: 'black',
  size: 30
};
IconShrinkScreen.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconShrinkScreen;
exports.default = _default;